module.exports = __webpack_public_path__ + "media/images/recruitment/products/product-3-5a135aa2a6ca958168d78830ff2507ab.jpg";